import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterVaultListName',
})
export class FilterVaultListName implements PipeTransform {
  transform(list: any[], searchText: string = ''): any[] {
    if (!searchText || !(list || []).length) {
      return list;
    }
    return list.filter((x) => x.name?.toLowerCase().includes(searchText?.toLowerCase()));
  }
}
